import {
  MESSAGES_SUCCESS,MESSAGE_UPDATE, MESSAGES_FAILURE, SET_FILTERED_MESSAGES, GET_DEFERRED_MESSAGES, 
  TOGGLE_DEFERRED_SHOWN, UPDATE_MESSAGE_STATUS, ADD_MESSAGE_REACTION, REMOVE_MESSAGE_REACTION
} from '../../types/conversations'
import { getActiveUserId } from '../actionsHelpers'
import { apiConversation } from '../../../api'
import { MESSAGES_REQUEST } from '../../reducers/conversations/chat/loadingMessages'

const conversationsApi = apiConversation.conversations

export const updateMessage = (userId, message) => {
  return ({
    userId,
    message,
    type: MESSAGE_UPDATE,
  })
}
export const messagesRequest = ({ userId, fetching = true, fetchingUp = false }) => ({
  userId,
  fetching,
  fetchingUp,
  type: MESSAGES_REQUEST,
})
export const getMessagesSuccess = (userId, messages, isPoll = true, concat = true, up) => ({
  userId,
  messages,
  isPoll,
  concat,
  up,
  type: MESSAGES_SUCCESS
})
export const setMessagesWithFilters = (userId, messages) => ({
  userId,
  messages,
  type: SET_FILTERED_MESSAGES,
})
export const getMessagesFailure = (error) => ({ type: MESSAGES_FAILURE, error })
export const getDeferredMessagesSuccess = (userId, messages) => ({
  userId,
  messages,
  type: GET_DEFERRED_MESSAGES,
})
export const toggleDeferredShown = (userId) => ({
  userId,
  type: TOGGLE_DEFERRED_SHOWN
})

export const getMessages = ({ user, messages, isPoll = true, eventType, up }) => (dispatch, getState) => {
  const {
    conversations: {
      [user.id]: {
        chat: {
          messageFilters: { filterValue, filterText },
        },
      },
    },
    settings: { dateToSearchMessages }
  } = getState()

  dispatch(messagesRequest({
    userId: user.id,
    fetching: up ? false : true,
    fetchingUp: up ? true : false
  }))

  const params = {
    smaller: (!isPoll && !up) ? true : undefined,
    lastMessageDate: dateToSearchMessages
      ? dateToSearchMessages
      : messages.length > 0
        ? messages[(!isPoll && !up) ? messages.length - 1 : 0].date
        : undefined,
    userId: user.id,
    filterTypes: filterValue.join(','),
    text: filterText,
    fromDate: undefined,
    size: undefined,
    eventType
  }

  return conversationsApi.getMessages(params)
    .then(({ status, data }) => {
      if ([200, 204].includes(status)) {
        const { messages: newMessages, user: userId } = data

        if (newMessages.length <= 0) return

        if (up) {
          if (newMessages.length < 40) newMessages[0].lastMessage = true
        } else {
          if (newMessages.length < 40) newMessages[newMessages.length - 1].firstMessage = true
        }

        dispatch(getMessagesSuccess(userId, newMessages, isPoll, dateToSearchMessages ? false : true, up))
      } else {
        throw new Error('Data body not ok')
      }
    })
    .catch(error => dispatch(getMessagesFailure(error)))
    .finally(() => {
      dispatch(messagesRequest({ userId: user.id, fetching: false, fetchingUp: false }))
    })
}

export const getDeferredMessages = (user = {}) => (dispatch, getState) => {
  const userId = user.id || getActiveUserId(getState)
  const userState = (getState().conversations[userId] || {}).user
  if (!userState || !userState._id) return

  return conversationsApi
    .getDeferredMessages({ userId: userState._id })
    .then(({ data }) => {
      dispatch(getDeferredMessagesSuccess(userId, data.results))
    })
    .catch(() => {})
}

export const deleteDeferred = (deferredId) => (dispatch, getState) => {
  return conversationsApi
    .deleteDeferred(deferredId)
    .then(({ status }) => {
      if (![200, 204].includes(status)) {
        // dispatch(getDeferredMessages())
        throw new Error('Data body not ok')
      }
    })
}

export const updateMessageStatus = data => ({
  type: UPDATE_MESSAGE_STATUS,
  userId: data.userId,
  payload: data
})

export const addReaction = ({ userId, messageId, emoji }) => (dispatch) => {
  return conversationsApi.addReaction({ userId, messageId, emoji }).then(({ status }) => {
    if (status === 200) {
      dispatch({
        type: ADD_MESSAGE_REACTION,
        userId,
        messageId,
        emoji,
      })
    }
  })
}

export const removeReaction = ({ userId, messageId }) => (dispatch) => {
  return conversationsApi.removeReaction({ userId, messageId }).then(({ status }) => {
    if (status === 200) {
      dispatch({
        type: REMOVE_MESSAGE_REACTION,
        userId,
        messageId,
      })
    }
  })
}